import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { useI18n } from '../i18n';
import { inlineError } from '../hooks/useApiCall';
import { useBusy } from '../hooks/useBusy';
import { usePageTitle } from '../hooks/usePageTitle';
import { MailIcon } from '../components/shared/Icons';
import AuthCard from '../components/auth/AuthCard';
import AuthResult from '../components/auth/AuthResult';
import Notice from '../components/shared/Notice';
import Field from '../components/shared/Field';

export default function ForgotPassword() {
  const { t } = useI18n();
  usePageTitle(t.home.forgotPassword);
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  // #605, #664 — the lock of Send: a second tap sends no second mail.
  const send = useBusy();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    await send.run(async () => {
      setError('');
      try {
        await api.post('/api/auth/email/forgot-password', { email });
        setSent(true);
      } catch (err) {
        setError(inlineError(err));
      }
    });
  }

  return (
    <AuthCard title={t.home.forgotPassword} subtitle={t.home.forgotPasswordHint}>
      {sent ? (
        <AuthResult icon={MailIcon} tone="info" text={t.home.resetLinkSent}
          action={{ to: '/login', label: t.auth.backToLogin }} />
      ) : (
        <form onSubmit={handleSubmit} className="space-y-3">
          <Field label={t.home.email}>
            <input type="email" required className="input" value={email}
              onChange={e => setEmail(e.target.value)} autoFocus data-testid="forgot-email" />
          </Field>
          {error && <Notice tone="error">{error}</Notice>}
          <button type="submit" disabled={send.busy} className="btn-primary w-full py-2.5" data-testid="forgot-submit">
            {send.busy ? t.common.loading : t.home.sendResetLink}
          </button>
          <p className="text-center text-sm text-gray-500">
            <Link to="/login" className="text-gray-900 font-medium hover:underline">{t.auth.backToLogin}</Link>
          </p>
        </form>
      )}
    </AuthCard>
  );
}
